// Index file for the directory. Don't add anything else here.
import CarouselPublicExtendedData from './CarouselPublicExtendedData';
export default CarouselPublicExtendedData;
